$modalVideo=$("#modal-video");
$modalVideo.on("show.bs.modal", function (event) {
  var $button = $(event.relatedTarget); // Button that triggered the modal
  // If necessary, you could initiate an AJAX request here (and then do the updating in a callback).
  // Update the modal's content. We'll use jQuery here, but you could use a data binding library or other methods instead.
  var $modal = $(this);
  $modal.find("[data-role='title']").text($button.data("param-title"));
  $modal.find("[data-role='date']").text($button.data("param-date"));
  $modal.find("[data-role='subtitle']").text($button.data("param-subtitle"));
  $modal.find("iframe").attr("src",$button.data("param-src"));
});
$modalVideo.on("hide.bs.modal", function (event) {
  var $modal = $(this);
  $modal.find("iframe").attr("src","");
});